export default __webpack_public_path__ + "static/media/inclusion.02e50a62.png";